import {ModuleState} from '@fantasmagames/slot/src/common/ModuleState';
import {NetworkModule} from '@fantasmagames/slot/src/modules/network/NetworkModule';
import {ReelsEvents} from '@fantasmagames/slot/src/modules/reels/spin/ReelsEvents';
import {Action} from '@fantasmagames/slot/src/logic/Action';
import {AvalancheReelsEvents} from '@fantasmagames/slot/src/modules/reels/avalanche/AvalancheReelsEvents';
import {IndividualSymbolReelsEvents} from '@fantasmagames/slot/src/modules/reels/individual/IndividualSymbolReelsEvents';

export class NetworkBasicState extends ModuleState<null, NetworkModule> {
	public onEnterState(): void {
	}

	public onLeaveState(): void {
	}

	protected setupEvents(): void {
		this.on(ReelsEvents.REELS_SPINNING_STARTED, this.onReelsSpinningStarted);
		this.on(ReelsEvents.REELS_RESPIN_STARTED, this.onReelsRespinStarted);
		this.on(AvalancheReelsEvents.REMOVING_AVALANCE_SYMBOLS_STARTED, this.onAvalanche);
		this.on(AvalancheReelsEvents.SYMBOLS_RESPIN_STARTED, this.onReelsRespinStarted);
		this.on(IndividualSymbolReelsEvents.INDIVIDUAL_RESPIN_STARTED, this.onReelsRespinStarted);
	}

	protected onReelsSpinningStarted(): void {
		switch (this.module.logic.nextAction) {
			case Action.SPIN: {
				this.module.logic.spin(null);
				// this.module.logic.saveData(null);
				break;
			}
			case Action.FREESPIN: {
				this.module.logic.freeSpin(null);
				break;
			}

			default:
				this.otherActionHandling(this.module.logic.nextAction);
				break;
		}
	}

	protected otherActionHandling(nextAction: string): void {

	}

	protected onAvalanche(): void {
		if (this.module.logic.nextAction !== Action.AVALANCHE) {
			throw new Error('wrong next action = ' + this.module.logic.nextAction + ' expected to be respin');
		}
		this.module.logic.avalanche(null);
	}

	protected onReelsRespinStarted(): void {
		if (this.module.logic.nextAction !== Action.RESPIN) {
			throw new Error('wrong next action = ' + this.module.logic.nextAction + ' expected to be respin');
		}
		this.module.logic.respin(null);
	}
}



// WEBPACK FOOTER //
// ./@fantasmagames/slot/src/modules/network/states/NetworkBasicState.ts